import { get } from "lodash-es";

// Example Usage:
//
// const buttonBackground = propStyle("color", {
//   light: "#fff",
//   dark: "#111"
// }, { defaultKey: "light" });
//
// const BaseButton = styled.button`
//   background: ${buttonBackground};
// `
export const propStyle = (
  propName: string,
  styles: object,
  { defaultValue = "", defaultKey = "" }
) => (props: object) =>
  get(styles, get(props, propName, defaultKey), defaultValue);

// Example Usage:
//
// const BaseButton = styled.button`
//   box-shadow: ${themeStyle('shadows.raised', "none")};
// `
export const themeStyle = (key: string, defaultValue = "") => (props: object) =>
  get(props, `theme.${key}`, defaultValue);

// Example Usage:
//
// const BaseButton = styled.button`
//    background: ${modeStyle('white', 'black')}
// `
export const modeStyle = (lightModeStyle: string, darkModeStyle: string) => (
  props: object
) => {
  const isDarkMode = get(props, `theme.darkMode`, false);
  if (isDarkMode) return darkModeStyle;
  return lightModeStyle;
};
